import { Controller } from "@hotwired/stimulus"

export default class MvcDrawerController extends Controller {
    connect(): void {
        this.element.parentNode?.addEventListener('MDCTopAppBar:nav', (e) => {
            // @ts-ignore
            this.element.open = !this.element.open;
        })
    }
}